module.exports = __webpack_public_path__ + "img/385.afce3337.png";